import { observer } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import doctorClinicJoinPromptStore from "../../stores/DoctorClinicJoin/doctorClinicJoinPromptStore";

/**
 * Global dialog asking the user to confirm creating a NEW doctor↔clinic
 * association before it is persisted. Rendered once at the app root; driven by
 * `doctorClinicJoinPromptStore`. Closing via backdrop/escape counts as cancel
 * (the non-destructive choice — no association is created).
 */
const DoctorClinicJoinConfirmDialog = observer(() => {
  const { open, context } = doctorClinicJoinPromptStore;

  const doctorLabel = context
    ? [context.doctorName, context.doctorLANR && `(LANR ${context.doctorLANR})`]
        .filter(Boolean)
        .join(" ")
        .trim()
    : "";
  const clinicLabel = context
    ? [context.clinicName, context.clinicBSNR && `(BSNR ${context.clinicBSNR})`]
        .filter(Boolean)
        .join(" ")
        .trim()
    : "";

  return (
    <Dialog
      open={open}
      onClose={() => doctorClinicJoinPromptStore.cancel()}
      PaperProps={{ style: { zIndex: 2100 } }}
    >
      <DialogTitle>Neue Arzt-Praxis-Verknüpfung</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {doctorLabel || "Dieser Arzt"} ist noch nicht mit {clinicLabel || "dieser Praxis"}{" "}
          verknüpft. Möchten Sie diese Verknüpfung jetzt erstellen? Bitte prüfen Sie, ob der
          richtige Arzt ausgewählt wurde.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => doctorClinicJoinPromptStore.cancel()}>Abbrechen</Button>
        <Button variant="contained" onClick={() => doctorClinicJoinPromptStore.confirm()}>
          Verknüpfen
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DoctorClinicJoinConfirmDialog;
